<template>
  <div class="deletable-avatar">
    <profile-preview-image
      :profileId="user.profileId"
      :uuid="user.uuid"
      :avatarClasses="['bh-user__avatar', 'avatar', 'rounded-pill']"
      :avatarSize="48"
      :thumbnailUrl="user.thumbnailUrl"
    />
    <span>{{user.firstName}}</span>
    <v-icon size="16" @click="$emit('remove', user.id)">bhi-close-circle-filled</v-icon>
  </div>
</template>

<script>
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
export default {
  name: 'DeletableAvatar',
  components: {
    ProfilePreviewImage,
  },
  props: {
    user: {
      type: Object,
      default: ()=>{},
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.deletable-avatar {
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  z-index: 2;
  margin-right:12px;

  @include imageAvatar(
    $class-name: 'multi-avatar',
    $height: 48px,
    $width: 48px,
    $radius: 24px
  );
  span {
    font-size: 0.8rem;
  }
  .v-icon {
    position: absolute;
    top: 16px;
    right: -8px;
    border-radius: 8px;
    border: 2px solid $bh-white;
  }
}
</style>